import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ContentDisplay } from '../components/form-wrapper/ContentDisplay';
import { FormWrapper } from '../components/form-wrapper/FormWrapper';
import { API_BASE_URL } from '../config'

interface FormConfig {
  fields: any[];
  pages: any[];
  form_data: {
    title: string;
    description: string;
  };
}

export const ContentPageComponent: React.FC = () => {
  const { formId } = useParams<{ formId: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [formConfig, setFormConfig] = useState<FormConfig | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Get the token from localStorage or wherever you store it
        const token = localStorage.getItem('token');
        
        if (!token) {
          throw new Error('Authentication token not found');
        }

        if (!formId) {
          throw new Error('Form ID is required');
        }

        const response = await fetch(`${API_BASE_URL}/api/forms/form-config/${formId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          if (response.status === 401) {
            throw new Error('Unauthorized: Please log in again');
          }
          throw new Error('Failed to fetch form configuration');
        }
        
        const data = await response.json();
        
        // Transform the data to reattach customComponent where needed
        const transformedConfig: FormConfig = {
          ...data.config,
          fields: data.config.fields.map((field: any) => {
            if (field.type === 'content-display') {
              return {
                ...field,
                customComponent: ContentDisplay
              };
            }
            return field;
          })
        };

        setFormConfig(transformedConfig);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [formId]); // Added formId to dependency array

  const handleSubmit = async (data: Record<string, any>) => {
    console.log(data);
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (error || !formConfig) {
    return (
      <div className="h-screen flex items-center justify-center text-red-600">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="w-full flex justify-center p-5">
        <FormWrapper
          title={formConfig.form_data.title}
          description={formConfig.form_data.description}
          fields={formConfig.fields}
          pages={formConfig.pages}
          onSubmit={handleSubmit}
          width="100%"
          maxWidth="100vw"
          minHeight="100vh"
          submitButtonText="Complete Tutorial"
          fieldSpacing="even"
          buttonPosition="bottom"
          defaultSpacing="8"
          className="h-[100vh]"
        />
      </div>
    </div>
  );
};

export default ContentPageComponent;